"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getModelsWithAddedAccess = exports.getAccessToAllModels = exports.getAccessToAllowedModels = void 0;
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const licenses_1 = require("@completeanatomy/licenses");
const user_1 = require("@completeanatomy/user");
const hasActiveLicense = (state) => {
    return !!(state === null || state === void 0 ? void 0 : state.some((license) => license.isActive));
};
const getAccessToAllowedModels = (state) => {
    return !!(state === null || state === void 0 ? void 0 : state.filter(license => license.isActive &&
        (license.type === bridge_schema_1.LicenseType.School ||
            license.type === bridge_schema_1.LicenseType.Individual)).length);
};
exports.getAccessToAllowedModels = getAccessToAllowedModels;
const getAccessToAllModels = (state) => {
    return !!(state === null || state === void 0 ? void 0 : state.filter(license => license.isActive &&
        license.type !== bridge_schema_1.LicenseType.School &&
        license.type !== bridge_schema_1.LicenseType.Individual).length);
};
exports.getAccessToAllModels = getAccessToAllModels;
const allowedDetailedModelsTypes = [
    bridge_schema_1.ModelType.BloodVessel,
    bridge_schema_1.ModelType.SkeletalSystem, // Bone Cross Section
    bridge_schema_1.ModelType.BronchialTree,
    bridge_schema_1.ModelType.LymphoidSystem, // Lymph Node
    bridge_schema_1.ModelType.PeripheralNerve,
    bridge_schema_1.ModelType.SkeletalStriatedMuscle, // Skeletal Muscle
    bridge_schema_1.ModelType.SkeletalMuscleFiber,
    bridge_schema_1.ModelType.TheIntegument, // Skin
];
const getModelsWithAddedAccess = () => {
    const notRegistered = !(0, user_1.useUser)();
    const notPaid = !hasActiveLicense((0, licenses_1.useUserLicenses)());
    const hasAccessToAllowedModels = (0, exports.getAccessToAllowedModels)((0, licenses_1.useUserLicenses)());
    const hasAccessToAllModels = (0, exports.getAccessToAllModels)((0, licenses_1.useUserLicenses)());
    return (models) => {
        const modifyModels = models.map(model => model.isDetailed
            ? Object.assign(Object.assign({}, model), { access: bridge_schema_1.UIAccessModifier.Restricted }) : Object.assign(Object.assign({}, model), { access: bridge_schema_1.UIAccessModifier.Regular }));
        if (notRegistered || notPaid)
            return modifyModels;
        if (hasAccessToAllModels) {
            return modifyModels.map(model => (Object.assign(Object.assign({}, model), { access: bridge_schema_1.UIAccessModifier.Regular })));
        }
        if (hasAccessToAllowedModels && !hasAccessToAllModels) {
            return modifyModels.map(model => allowedDetailedModelsTypes.includes(model.type)
                ? Object.assign(Object.assign({}, model), { access: bridge_schema_1.UIAccessModifier.Regular }) : model);
        }
        return [];
    };
};
exports.getModelsWithAddedAccess = getModelsWithAddedAccess;
